function isJson(str) {
    try {
        var data = JSON.parse(str);
        if (data !== null && typeof data === "object") {
            return true;
        }
    }
    catch (e) {
        return false;
    }
    return false;
}
function readCookie(name) {
    var arr = null;
    var reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
    if (document.cookie && (arr = document.cookie.match(reg))) {
        return unescape(arr[2]);
    }
    else {
        return null;
    }
}
var on = (function () {
    return function (el, event, handle) {
        if (el && event && handle) {
            el.addEventListener(event, handle, false);
        }
    };
})();
var off = (function () {
    return function (el, event, handle) {
        if (el && event && handle) {
            el.removeEventListener(event, handle, el);
        }
    };
})();
function promiseControl() {
    var rev, rej;
    var pms = new Promise(function (resolve, reject) {
        rev = resolve;
        rej = reject;
    });
    return [pms, rev, rej];
}
function objectValues(obj) {
    var values = [];
    for (var key in obj) {
        if (obj.hasOwnProperty(key)) {
            values.push(obj[key]);
        }
    }
    return values;
}
function arrayIncludes(arr, value) {
    for (var i = 0; i < arr.length; i++) {
        if (arr[i] === value) {
            return true;
        }
    }
    return false;
}
function stringIncludes(str, searchValue) {
    return str.indexOf(searchValue) !== -1;
}
function arrayFind(arr, callback) {
    if (typeof callback !== 'function') {
        throw new TypeError('Callback must be a function');
    }
    for (var i = 0; i < arr.length; i++) {
        if (callback.call(arr, arr[i], i, arr)) {
            return arr[i];
        }
    }
    return undefined;
}
export { isJson, readCookie, promiseControl, on, off, objectValues, arrayIncludes, arrayFind, stringIncludes };
//# sourceMappingURL=index.js.map